'use client';

import { useCallback, useState } from 'react';
import { useUnit } from 'effector-react';
import { Button, ButtonSize, ButtonType } from '@nx-frontend/shared/ui/button';
import { UiTextArea } from '@nx-frontend/shared/ui/textarea';
import { $guideGen, startGuidGenEvent } from '@nx-frontend/webnotes-client/shared/store';

export function Guidegen() {
  const [guideGen, startGuidGen] = useUnit([$guideGen, startGuidGenEvent]);
  const [textDescription, setTextDescription] = useState('');

  const onGenGuides = useCallback(() => {
    startGuidGen({ videoDescription: textDescription });
  }, [startGuidGen, textDescription]);

  if (!guideGen.active) {
    return null;
  }

  if (guideGen.generating) {
    return (
      <div className="inset-0 fixed bg-slate-400/70 z-40 p-40">
        <div className="text-white">Generating guide...</div>
      </div>
    );
  }

  return (
    <div className="inset-0 fixed bg-slate-400/70 z-40 p-40">
      <UiTextArea
        id="video_description"
        label="Video description"
        value={textDescription}
        name="video_description"
        placeholder="Enter video description"
        onChange={(e) => {
          setTextDescription(e.target.value);
        }}
      />
      <Button type={ButtonType.FLAT} size={ButtonSize.MD} onClick={onGenGuides}>
        Create Guide
      </Button>
    </div>
  );
}
